export const ButtonStyles = `
-webkit-appearance: none;
-webkit-font-smoothing: antialiased;
align-items: flex-start;
background-color: rgb(0, 0, 0);
border: 1px solid black;
border-radius: 3px;
color: rgb(255, 255, 255);
cursor: pointer;
font-family: 'Twentieth Century', sans-serif;
font-size: 14.875px;

height: 47px;
letter-spacing: 0.14875000715255737px;
line-height: 17px;
padding: 14px 5px;

text-align: center;
text-decoration: none;


text-transform: uppercase;

transition-duration: 0.2s, 0.2s, 0.2s, 0.2s;
transition-property: border-color, background-color, width, height;
transition-timing-function: ease, ease, ease, ease;
width: 100%; 
word-spacing: 0px;
writing-mode: horizontal-tb;
display: flex;
align-items: center;
justify-content: center;

&:hover {
  background-color: rgb(129, 192, 197);
  border: 1px solid rgb(129, 192, 197);
}
`
